<template>
  <div class="cart-item-wrapper d-flex align-start my-4">
    <input type="checkbox" :id="item.cart_detail_id" @click.prevent="set(proxy)" :value="item" v-model="proxy" />
    <label :for="item.cart_detail_id"></label>
    <!-- ml-15 -->
    <div
      class="d-flex justify-space-between align-start w-100"
      :class="{
        'ml-15': $vuetify.breakpoint.smAndUp,
        'ml-8': !$vuetify.breakpoint.smAndUp
      }"
    >
      <div style="position: relative">
        <div class="voucher-image rounded-lg elevation-3" v-if="item.product_category_id === 7">
          <v-img src="@/assets/voucher-detail.png" aspect-ratio="1" width="100%" height="100%" contain />
        </div>
        <v-img v-else :src="item.image" class="cart-image rounded-lg elevation-3" :class="{ 'unavailable-item': item.stock_status !== 'In Stock' }" aspect-ratio="1" />
        <div v-if="item.discount_percentage != 0" class="discount font-weight-bold primary lighten-1 d-flex flex-column align-center justify-center white--text rounded-circle">
          <span>{{ item.discount_percentage }}%</span>
          <span>{{ $t('label.discountOff') }}</span>
        </div>
      </div>
      <!-- <div style="position: relative" class="orange">
        <img v-if="item.product_category === 'Vouchers'" src="@/assets/voucher-detail.png" class="mr-5 voucher-image rounded-lg elevation-3" />
        <img v-else :src="item.image" class="mr-5 cart-image rounded-lg elevation-3" />
        <div v-if="item.discount_percentage != 0" class="discount font-weight-bold primary lighten-1 d-flex flex-column align-center justify-center white--text rounded-circle">
          <span>{{ item.discount_percentage }}%</span>
          <span>{{ $t('label.discountOff') }}</span>
        </div>
      </div> -->
      <div
        class="d-flex w-100 ml-5"
        :class="{
          'flex-row justify-space-between align-start': $vuetify.breakpoint.smAndUp,
          'flex-column justify-space-between align-start': !$vuetify.breakpoint.smAndUp
        }"
      >
        <div>
          <p class="text-subtitle-2 font-weight-bold grey--text">{{ item.product_subcategory }}</p>
          <p class="text-body secondary--text mb-2" style="line-height: 120%; word-break: break-all">{{ item.product_name }}</p>
          <p class="text-body secondary--text mb-2" style="line-height: 120%" v-if="item.volume_variation === 1">
            {{ item.product_volume_variation_name }}
            <v-icon color="grey--text" class="transparent" dense @click="onSelectVariation" v-if="item.volume_variations && item.volume_variations.length > 0">mdi-chevron-down</v-icon>
          </p>
          <v-btn fab depressed x-small color="transparent" class="disable-hover-bg" :ripple="false"><v-icon color="white" class="transparent">mdi-chevron-down</v-icon></v-btn>
        </div>
        <div
          :class="{
            'w-100': !$vuetify.breakpoint.smAndUp
          }"
        >
          <div>
            <QuantityTicker :value="quantity" @increment="increment" @decrement="decrement" :max="max" :min="item.minimum" class="d-inline-block" />
            <v-btn fab depressed color="white" x-small class="ml-3" v-if="isInWishList" @click.prevent="removeFromWishlist">
              <v-icon color="primary" class="transparent text--lighten-1">$heart_full</v-icon>
            </v-btn>
            <v-btn fab depressed color="white" x-small class="ml-3" v-else @click.prevent="addToWishlist">
              <v-icon color="primary" class="transparent text--lighten-1">$heart</v-icon>
            </v-btn>
            <v-btn
              fab
              depressed
              color="white"
              x-small
              :class="{
                'ml-3': $vuetify.breakpoint.smAndUp,
                'ml-1': !$vuetify.breakpoint.smAndUp
              }"
              @click="removeItem(item.product_id)"
            >
              <v-icon color="primary" class="transparent text--lighten-1">mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
          <div class="mt-2" v-if="(item.limit_per_order && quantity > item.limit_per_order) || (item.subtract_stock && quantity > item.quantity)">
            <span class="red--text font-weight-medium text-body-1">Max = {{ max }}</span>
          </div>
          <div v-if="item.agent_price" class="d-flex flex-column mt-4">
            <span class="orange--text text-subtitle-2 font-weight-medium" style="line-height: 90%">{{ $t('label.partnerPrice') }}</span>
            <span class="font-weight-bold orange--text text-subtitle-1">{{ `${item.currency} ${item.agent_price ? formatPrice(item.agent_price) : formatPrice(item.final_price)}` }}</span>
          </div>
          <div v-else class="d-flex flex-column mt-4">
            <span class="font-weight-medium grey--text text--darken-2 text-subtitle-2" style="line-height: 90%">{{ $t('label.retailPrice') }}</span>
            <div class="d-flex flex-row">
              <span
                class="font-weight-bold grey--text text--darken-2 text-subtitle-1"
                :class="{
                  'text-decoration-line-through': isDiscounted
                }"
              >
                {{ `${item.currency} ${item.agent_price ? formatPrice(item.agent_price) : formatPrice(item.final_price)}` }}
              </span>
              <span v-if="isDiscounted" class="grey--text text--darken-2 font-weight-bold text-subtitle-1 ml-3">
                {{ `${item.currency} ${formatPrice(item.discounted_price)}` }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog content-class="elevation-0" v-model="showVariations" max-width="700">
      <v-card class="white elevation-0 text-center d-flex flex-column">
        <div class="d-flex flex-row w-full justify-space-between align-center white w-full pt-16 pb-8 rounded-0 px-sm-8" v-if="item.volume_variation === 1" style="overflow-x: hidden">
          <v-btn icon color="grey darken-2" @click="showPrev" class="transparent" :x-small="!$vuetify.breakpoint.smAndUp">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <div class="carousel-container">
            <VueSlickCarousel ref="carousel" :arrows="false" :slidesToShow="$vuetify.breakpoint.smAndUp ? ($vuetify.breakpoint.lgAndUp ? 4 : 3) : 3" :infinite="false">
              <div v-for="variation in item.volume_variations" :key="variation.id">
                <div class="rounded-lg d-flex flex-column justify-center align-center ma-2">
                  <div
                    class="text-center variation-box w-full grey lighten-2 rounded-lg"
                    :class="{
                      'primary lighten-1': selectedVariation === variation.id && variation.stock_status !== 'Out of Stock',
                      'grey lighten-1': variation.stock_status === 'Out of Stock' && selectedVariation === variation.id
                    }"
                  >
                    <div
                      class="variation-img rounded-t-lg d-flex flex-column justify-center align-center"
                      :class="{ 'variation-active': selectedVariation === variation.id, 'variation-out-of-stock': variation.stock_status === 'Out of Stock' && selectedVariation === variation.id }"
                      :style="{ backgroundImage: `url(${variation.image})` }"
                      @click.prevent="setVariation(variation.id)"
                    >
                      <span class="enlarge-icon" @click="viewImage(variation.image)">
                        <v-icon small color="primary" class="transparent">$enlarge</v-icon>
                      </span>
                    </div>
                    <div :class="{ 'white--text': selectedVariation == variation.id }">{{ variation.name }}</div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
          <v-btn icon color="grey darken-2" @click="showNext" :x-small="!$vuetify.breakpoint.smAndUp">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div class="w-full d-flex">
          <div class="d-flex flex-row align-center ma-auto">
            <app-button class="green-gradient-right override-disabled-styles mb-5 ml-auto" @click="updateVariation" invert gradient :label="$t('button.update')" :disabled="!canUpdate" />
            <app-button class="mb-5 ml-2" @click="cancelUpdate" :label="$t('button.cancel')" />
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog content-class="elevation-0" v-model="imageOverlay" max-width="500">
      <ProductImagePreview @input="imageOverlay = false" :imageSrc="selectedImage" />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { localeHelper, uiHelper } from '@/utils'
import VueSlickCarousel from 'vue-slick-carousel'
import QuantityTicker from '../QuantityTicker.vue'
import ProductImagePreview from '@/components/product/ProductImagePreview.vue'
import ProductMixin from '@/mixins/product.mixin.js'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { QuantityTicker, VueSlickCarousel, ProductImagePreview },
  mixins: [ProductMixin],
  props: {
    // value refers to itemsForCheckout
    value: { required: true },
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      quantity: this.item.cart_quantity,
      proxy: [],
      showVariations: false,
      selectedVariation: this.item.product_volume_variation_id,
      selectedImage: null,
      imageOverlay: false
    }
  },
  watch: {
    value(val) {
      this.proxy = val
    }
  },
  mounted() {
    this.proxy = this.value
  },
  computed: {
    ...mapState('wishlist', ['wishlist']),
    max() {
      if ((this.item.quantity > this.item.limit_per_order || !this.item.subtract_stock) && this.item.limit_per_order) {
        return this.item.limit_per_order
      }
      if (!this.item.subtract_stock && this.item.limit_per_order < 1) {
        return -1
      }
      return this.item.quantity
    },
    isDiscounted() {
      return this.item.discounted_price != null && this.item.discounted_price != ''
    },
    isInWishList() {
      let result
      if (this.item.volume_variation === 0) result = this.wishlist.length > 0 && this.wishlist.findIndex((f) => f.id === this.item.product_id) > -1
      else {
        result = this.wishlist.length > 0 && this.wishlist.findIndex((f) => f.product_volume_variation_id === this.item.product_volume_variation_id) > -1
      }
      return result
    },
    canUpdate() {
      let res = true
      if (this.item.volume_variation === 1 && this.item.volume_variations.length > 0) {
        let arrIndex = this.item.volume_variations.findIndex((f) => f.id === this.selectedVariation)
        if (arrIndex > -1) res = this.item.volume_variations[arrIndex].stock_status !== 'Out of Stock'
      }
      return res
    }
  },
  methods: {
    ...mapActions('wishlist', ['addWishlist', 'deleteWishlist']),
    ...mapActions('order', ['getCartItem', 'editCheckoutItem', 'editCart', 'changeProductVolumeVariation']),
    increment() {
      if (!this.item.subtract_stock || this.quantity < this.item.quantity) {
        this.quantity++
        this.editCartQuantity()
      }
      return
    },
    decrement() {
      if (this.quantity > 1) {
        this.quantity--
        this.editCartQuantity()
      }
      return
    },
    editCartQuantity() {
      this.item.cart_quantity = this.quantity
      this.editCartItem([this.item])
    },
    removeItem() {
      let body = { product_id: { product_id: [this.item.product_id] } }
      if (this.item.volume_variation === 1) body = { product_volume_variation_id: { product_volume_variation_id: [this.item.product_volume_variation_id] } }
      this.$emit('remove', body)
    },
    async addToWishlist() {
      let body = { product_id: this.item.product_id }
      if (this.item.volume_variation === 1) Object.assign(body, { product_volume_variation_id: this.item.product_volume_variation_id })
      await this.addWishlist(body)
    },
    async removeFromWishlist() {
      let index
      if (this.productData.product.volume_variation === 0) index = this.wishlist.findIndex((f) => f.id === parseInt(this.item.product_id))
      else {
        index = this.wishlist.findIndex((f) => f.product_volume_variation_id === this.item.product_volume_variation_id)
      }
      await this.deleteWishlist([this.wishlist[index].wish_id])
    },
    async set(val) {
      if (!this.item.is_checked) {
        await this.getCartItem()
        if ((this.item.subtract_stock && this.quantity > this.item.quantity) || (this.item.limit_per_order && this.quantity > this.item.limit_per_order)) {
          // resetting checked item
          let filteredArr = val.map((item) => {
            if (item.cart_detail_id == this.item.cart_detail_id) {
              item.is_checked = false
            }
            return item
          })
          await this.editCheckoutItem(filteredArr)
          this.$emit('error', this.$t('message.cartMaxQuantityPerOrder', { product: this.item.product_name, quantity: this.item.quantity }), this.item.product_id)
          return
        }
        if (this.item.volume_variation === 1) {
          if (!this.item.volume_variations || this.item.volume_variations.length === 0) {
            this.$emit('error', this.$t('error.productNotExist'))
            return
          } else if (this.item.volume_variations.length > 0 && !this.item.volume_variations.filter((f) => f.id === this.item.product_volume_variation_id).length > 0) {
            this.$emit('error', this.$t('error.volumeVariationNotExist'))
            return
          }
        }
      }
      this.item.is_checked = !this.item.is_checked
      let arr = [this.item]
      let requestObj = {
        products: arr.map((item) => {
          let body = {
            product_id: item.product_id,
            quantity: item.cart_quantity,
            is_checked: item.is_checked
          }
          if (item.volume_variation === 1) Object.assign(body, { product_volume_variation_id: item.product_volume_variation_id })
          return body
        })
      }
      await this.editCart(requestObj).catch((err) => {
        this.$toast.error(err.error_message)
      })
    },
    formatPrice(val) {
      return uiHelper.priceFormatter(val)
    },
    onSelectVariation() {
      this.showVariations = true
    },
    showNext() {
      this.$refs.carousel.next()
      let currentIndex = this.item.volume_variations.findIndex((f) => f.id === this.selectedVariation)
      let nextIndex = currentIndex + 1
      if (currentIndex > -1 && nextIndex < this.item.volume_variations.length) this.selectedVariation = this.item.volume_variations[nextIndex].id
    },
    showPrev() {
      this.$refs.carousel.prev()
      let currentIndex = this.item.volume_variations.findIndex((f) => f.id === this.selectedVariation)
      let prevIndex = currentIndex - 1
      if (currentIndex > -1 && prevIndex > -1) this.selectedVariation = this.item.volume_variations[prevIndex].id
    },
    viewImage(url) {
      this.selectedImage = url
      this.imageOverlay = true
    },
    setVariation(id) {
      this.selectedVariation = id
    },
    cancelUpdate() {
      this.selectedVariation = this.item.product_volume_variation_id
      this.showVariations = false
    },
    async updateVariation() {
      let body = { cart_detail_id: this.item.cart_detail_id, product_id: this.item.product_id, product_volume_variation_id: this.selectedVariation }
      if (this.item.product_volume_variation_id !== this.selectedVariation) {
        await this.changeProductVolumeVariation(body)
          .then(() => this.$emit('refetch'))
          .catch((err) => {
            this.$toast.error(err.error_message)
          })
      }
      this.showVariations = false
    }
  }
}
</script>

<style lang="scss" scoped>
/* Base for label styling */
[type='checkbox']:not(:checked),
[type='checkbox']:checked {
  appearance: none;
}

[type='checkbox']:not(:checked) + label,
[type='checkbox']:checked + label {
  position: relative;
  font-size: 1.05em;
  line-height: 1.7;
  cursor: pointer;
  display: inline-block;
}

/* checkbox circle */
[type='checkbox']:not(:checked) + label:before,
[type='checkbox']:checked + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 1.5em;
  height: 1.5em;
  border: 1px solid #aaa;
  background: #fff;
  border-radius: 999em;
  -webkit-transition: all 0.275s;
  transition: all 0.275s;

  @media only screen and (min-width: 640px) {
    width: 2em;
    height: 2em;
  }
}

[type='checkbox']:checked + label:before {
  background-color: var(--v-light-green-base);
}

/* checked mark aspect */
[type='checkbox']:not(:checked) + label:after,
[type='checkbox']:checked + label:after {
  content: '';
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  width: 0.5em;
  height: 1em;
  position: absolute;
  top: 0.4em;
  left: 0.75em;
  font-size: 0.75em;
  color: white;
  line-height: 0;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;

  @media only screen and (min-width: 640px) {
    top: 0.1em;
    left: 0.45em;
    font-size: 1.375em;
  }
}

/* checked mark aspect changes */
[type='checkbox']:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0) rotate(-45deg);
  transform: scale(0) rotate(-45deg);
}

[type='checkbox']:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1) rotate(45deg);
  transform: scale(1) rotate(45deg);
}

/* Accessibility */
[type='checkbox']:checked:focus + label:before,
[type='checkbox']:not(:checked):focus + label:before {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) inset, 0 0 0 4px rgba(#74ce00, 0.5);
}

.cart-image {
  width: 120px;
  height: 120px;
  object-fit: cover;

  @media only screen and (min-width: 640px) {
    width: 180px;
    height: 180px;
  }
  @media only screen and (min-width: 1800px) {
    width: 200px;
    height: 200px;
  }
}

.voucher-image {
  width: 120px;
  height: 120px;
  padding: 2% 15%;

  @media only screen and (min-width: 640px) {
    width: 180px;
    height: 180px;
  }
  @media only screen and (min-width: 1800px) {
    width: 200px;
    height: 200px;
  }
}

.discount {
  position: absolute;
  right: 8%;
  top: 4%;
  height: 30px;
  width: 30px;
  font-size: 0.7rem;
  line-height: 1;

  @media only screen and (min-width: 640px) {
    height: 50px;
    width: 50px;
    font-size: 0.8rem;
  }
  @media only screen and (min-width: 1800px) {
    height: 50px;
    width: 50px;
    font-size: 0.8rem;
  }
}

.carousel-container {
  width: 280px;

  @media only screen and (min-width: 640px) {
    width: 320px;
  }

  @media only screen and (min-width: 1000px) {
    width: 400px;
  }

  @media only screen and (min-width: 1200px) {
    width: 500px;
  }

  @media only screen and (min-width: 1400px) {
    width: 600px;
  }
}

.variation-img {
  position: relative;
  width: 85px;
  height: 90px;
  background-position: center center;
  background-repeat: no-repeat;
  object-fit: cover;
  object-fit: scale-down;
  background-size: cover;
  border: 4px solid #e0e0e0 !important;

  @media only screen and (min-width: 640px) {
    width: 95px;
    height: 100px;
  }

  @media only screen and (min-width: 1800px) {
    width: 95px;
    height: 100px;
  }
}

.article {
  box-shadow: inset 0 0 0 200px rgba(0, 0, 0, 0.5);
}
.variation-img:hover {
  cursor: pointer;
  border: 2px solid rgba(116, 206, 0, 0.7);
}
.variation-active {
  border: 4px solid rgba(116, 206, 0, 0.7) !important;
}

.variation-out-of-stock {
  border: 4px solid #c2c2c2 !important;
}

.enlarge-icon {
  position: absolute;
  top: -2%;
  right: 3%;
}
</style>
